import { Check } from "lucide-react";

const POINTS = [
  "Real-estate-only focus, deep India market expertise",
  "RERA-compliant creative & legal review",
  "In-house drone, 3D & site-shoot crew",
  "Brand → Demand → Leads → Bookings framework",
  "Weekly war-rooms with your sales team",
  "500+ projects marketed end-to-end",
];

export default function About() {
  return (
    <section data-testid="about-section" className="relative py-24 sm:py-32 border-t border-white/5 overflow-hidden">
      <div className="absolute -top-20 left-0 w-[400px] h-[400px] rounded-full bg-emerald-500/10 blur-[140px]" />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 items-start">
        <div>
          <div className="font-mono text-xs text-[#d4ff4f] mb-3 tracking-[0.2em]">#रोटी_कपड़ा_और_मकान</div>
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40 mb-4">/ About Digi Savvy</div>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95]">
            Built for builders.<br />
            Run by marketers.<br />
            <span className="italic text-[#d4ff4f]">Obsessed with bookings.</span>
          </h2>
        </div>
        <div>
          <p className="text-white/70 leading-relaxed">
            We run lead engines for <span className="text-white">50+ builders, developers and channel partners</span> across India, from boutique floor developers in Delhi to marquee townships in Gurugram and the NRI investor corridor in Noida, Lucknow and Dubai. We obsess over <span className="text-[#d4ff4f]">Brand → Demand → Leads → Bookings</span>, not cost-per-click.
          </p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {POINTS.map((p, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-white/70" data-testid={`about-point-${i}`}>
                <span className="mt-0.5 w-5 h-5 rounded-full bg-[#d4ff4f]/15 border border-[#d4ff4f]/40 flex items-center justify-center shrink-0">
                  <Check className="w-3 h-3 text-[#d4ff4f]" />
                </span>
                {p}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
